<template>
  <div class="site-drawer-wrapper" :style="{zIndex:zIndex}">
    <transition v-if="overlay" name="fade">
      <div v-if="open" class="site-drawer-overlay" :style="{'background':overlay}"></div>
    </transition>

    <transition :name="position">
      <div ref="target" v-show="open" class="site-drawer" :class="{
                    'off-canvas': behavior==='push',
                    'pos-top': position==='top',
                    'pos-right': position==='right'
                }" :style="{
                    'background': background,
                    'max-width': maxWidth
                }">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: {
      position: {
        type: String,
        required: false,
        default: 'top'
      },
      behavior: {
        type: String,
        required: false,
        default: 'overlay'
      },
      background: {
        type: String,
        required: false,
        default: '#fff'
      },
      maxWidth: {
        type: String,
        required: false,
        default: '100%'
      },
      zIndex: {
        type: String,
        required: false,
        default: '1000'
      },
      overlay: {
        type: String,
        required: false,
        default: null
      },
      scrollTarget: {
        type: String,
        required: true,
        default: null
      }
    },
    data() {
      return {
        open: false
      }
    }
  }
</script>

<style lang="scss">
  .site-drawer-wrapper {
    position: relative;

    .site-drawer {
      position: fixed;
      display: block;
      height: 100vh;
      width: 100%;
      min-width: 200px;

      &.pos-top {
        top: 0;
        left: 0;
      }

      &.pos-right {
        right: 0;
        top: 0;
      }

      &.pos-left {
        left: 0;
        top: 0;
      }
    }

    .site-drawer-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 100%;
    }
  }

  // Transitions
  .top-enter-active,
  .top-leave-active,
  .right-enter-active,
  .right-leave-active,
  .left-enter-active,
  .left-leave-active {
    transition: transform 500ms ease-out, opacity 750ms ease-out;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 250ms ease-out;
  }

  .top-enter,
  .top-leave-to {
    transform: translateY(-100%);
    opacity: 0;
  }

  .right-enter,
  .right-leave-to {
    transform: translateX(100%);
    opacity: 0;
  }

  .left-enter,
  .left-leave-to {
    transform: translateX(-100%);
    opacity: 0;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>